// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.custom-table .v-data-table table tfoot th {\r\n    position: sticky;\r\n    bottom: 0;\n}\n.custom-table table {\r\n    width: 100%;\r\n    border-collapse: collapse;\n}\n.custom-table th,\r\n.custom-table td {\r\n    border: 2px solid black;\r\n    padding: 8px;\r\n    text-align: left;\r\n    width: 12.5%;\n}\r\n", ""]);
// Exports
module.exports = exports;
